import { useState, useEffect } from 'react';
import { canUseDOM } from '../../utils';
export function useMobileNav(isMobile) {
  let displayMobMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [mobileNavVisible, setMobileNavVisible] = useState(false);
  const [mobileNavActiveIndex, setMobileNavActiveIndex] = useState(-1);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const html = document.querySelector('html');
    if (html) {
      if (typeof window !== 'undefined') {
        if (mobileNavVisible) {
          html.style.overflowY = "hidden";
        } else {
          html.style.overflowY = "inherit";
        }
      }
    }
  }, [mobileNavVisible]);
  const handleMobileNavToggleClick = () => {
    if (displayMobMenu || window.matchMedia(`(max-width: ${isMobile ? '1200px' : '991px'})`).matches) {
      const happinessMeterWidget = canUseDOM ? document.querySelector('.happiness-meter-widget') : null;
      const htmlElement = canUseDOM ? document.querySelector('html') : null;
      if (htmlElement) {
        if (!mobileNavVisible) {
          htmlElement.classList.add('prevent-scroll');
          htmlElement.classList.add('mobile-nav-is-open');
        } else {
          htmlElement.classList.remove('prevent-scroll');
          htmlElement.classList.remove('mobile-nav-is-open');
        }
      }
      if (happinessMeterWidget) {
        happinessMeterWidget.style.zIndex = mobileNavVisible ? 'inherit' : '0';
      }
      setMobileNavVisible(!mobileNavVisible);
    }
  };
  const handleMobileNavDropdownClick = itemIndex => {
    if (displayMobMenu || window.matchMedia(`(max-width: ${isMobile ? '1200px' : '991px'})`).matches) {
      // If the clicked itemIndex matches the active item index, then assume
      // the user is closing the active dropdown menu.

      const index = itemIndex !== mobileNavActiveIndex ? itemIndex : -1;
      setMobileNavActiveIndex(index);
    }
  };
  return {
    mobileNavVisible,
    mobileNavActiveIndex,
    handleMobileNavToggleClick,
    handleMobileNavDropdownClick
  };
}